/**
 * Pure path helpers for the inbox trees, mirroring regulationPaths.
 *
 * The canonical URL is the org-less `/inbox`: an inbox is a PERSON's mail, and
 * the same person is typically a member of several tenants — items from all of
 * them belong in one list, each tagged with the organization it came from.
 * `/$org/inbox` is the same store filtered to one tenant, for people who want
 * one organization's work at a time; nav points at the org-less one.
 *
 * @module components/inbox/inboxPaths
 */

/** True on both inbox trees; drives nav selection, never content. */
export function isInboxPathname(pathname: string): boolean {
  return /^(?:\/[^/]+)?\/inbox\/?$/.test(pathname);
}
